import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as LocalStorageUtils from "_core/utils/localstorage";

import './AppContainer.scss';

import * as Constants from "_core/configs/Constants";

const AppContainer = (props) => {
    const { tUser } = useSelector((store) => store.transaction);

    useEffect(() => {
        if (tUser) 
        {
            console.log("コンテナでリセット");
        }
    }, [tUser]);

    return (
    <div className={"app-container"}>
        {props.children}
    </div>
    )
};

export default AppContainer;
